import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SplittedTimeFormatPipe } from './splitted-time-format.pipe';



@NgModule({
  declarations: [
    SplittedTimeFormatPipe,
  ],
  exports: [
    SplittedTimeFormatPipe,
  ],
  imports: [
    CommonModule,
  ],
})
export class SplittedTimeFormatModule { }
